import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import WechatWorkFilledSvg from "@ant-design/icons-svg/es/asn/WechatWorkFilled";
import AntdIcon from "../components/AntdIcon";
var WechatWorkFilled = function WechatWorkFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: WechatWorkFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  WechatWorkFilled.displayName = 'WechatWorkFilled';
}
export default /*#__PURE__*/React.forwardRef(WechatWorkFilled);